import { validateJsonResponse } from './APIUtils';

export const fetchLanguages = () => {
  const url = `/api/qikserve/gfc2/languages`;

  return fetch(url)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};
